// store.js
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    globalUserRole: 'Hello from User Roles!',  // your global variable
    globalAllowedUserModules: ['Hello from Allowed User Roles!']
  },
  mutations: {
    setGlobalRole(state, newRole) {
      state.globalUserRole = newRole;
    },
    setGlobalAllowedUserModules(state, newAllowedModules) {
      state.globalAllowedUserModules = newAllowedModules;
    }
  },
  actions: {
    updateGlobalRole({ commit }, newRole) {
      commit('setGlobalRole', newRole);
    },
    updateGlobalAllowedUserModules({ commit }, newAllowedModules) {
      commit('setGlobalAllowedUserModules', newAllowedModules);
    },
  },
  getters: {
    globalUserRole: state => state.globalUserRole,
    globalAllowedUserModules: state => state.globalAllowedUserModules,
    globalIsUserAllowed: state => prefix => {
      return state.globalAllowedUserModules.includes(prefix);
    },
    globalVerifyCurrentUserRole: state => prefix => {
      return state.globalUserRole == prefix;
    }
  }
});
